import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/matchdayActiveBetsSummary.css';

import {BASE_VALUE} from '../../../constants/chips';
// helpers
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {roundNumber} from '../../../helpers/mathFunctions';
import {
    getAccaBetName,
    getLiveScore,
    getPotentialReturn,
    getRoundedOdds,
    isWinningBet
} from '../modules/matchday/helpers/matchdayHelper';
import {getMatchDayMarketNameByCode} from '../helpers/marketHelpers';
import {getMarketByCode} from '../modules/matchday/helpers/marketHelpers';
import {UNDER_OVER_25} from '../modules/football/constants/marketTypes';
import {OPERATOR} from '../../../constants/operator';
import {getOddsFromOddsType} from '../../../helpers/oddsHelpers';
import {calculateTimeDifference} from '../../../helpers/helperFunctions';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        serverTimeOffset: state.vpp.serverTimeOffset,
        selectedOddsType: state.vpp.selectedOddsType,
    };
};

class MatchdayActiveBetsSummary extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            selectedOddsType: storeData.vpp.selectedOddsType,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                games: storeData.vpp.games,
                selectedOddsType: storeData.vpp.selectedOddsType,
            });
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({time: Date.now()}), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _generateHistoryHeaderRow() {
        return (<div className={`${style.betHistoryRowHeader} ${style.title}`}>
            <div className={`${style.stake} ${style.title}`}>{getText('BET_TYPE_STAKE', this.props.store)}</div>
            <div className={`${style.selection} ${style.title}`}>{getText('SELECTION', this.props.store)}</div>
            <div
                className={`${style.potentialReturnsHeader} ${style.title}`}>{getText('POTENTIAL_RETURNS', this.props.store)}</div>
        </div>);
    }

    _getMatchdayEventLiveScore(eventId, eventTime) {

        let score = getLiveScore(eventId, eventTime, this.state.games[this.state.selectedGameIndex], this.state.serverTimeOffset,);
        return ' ' + score + ' ';
    }

    _generateHistoryRowUI(bet, selectionIndex) {
        let storeData = this.props.store.getState().vpp;
        let systemCurrency = storeData.systemCurrency;

        let marketDetails = this._generateMarketDetails(bet);

        let header = (<div className={style.selectionHeader}>{marketDetails.name}</div>)

        let winningCss = `${style.matchdayBetContainer} ${style.win}`;
        let losingCss = `${style.matchdayBetContainer} ${style.lose}`;
        let data = (
            <div className={isWinningBet(bet, this.state.games[this.state.selectedGameIndex], this.state.serverTimeOffset) ? winningCss : losingCss}>
                <div className={`${style.selectedBetDetail} ${style.left}`}>{this._getSelectionName(bet)}</div>
                <div
                    className={`${style.selectedBetDetailLarge} ${style.center}`}>{getText("Matchday_" + bet.EventDetails.team1, this.props.store)}{this._getMatchdayEventLiveScore(bet.EventId, bet.EventTime)}{getText("Matchday_" + bet.EventDetails.team2, this.props.store)}</div>
                <div
                    className={`${style.selectedBetDetail} ${style.right}`}>{getOddsFromOddsType(bet.Market.Price, this.state.selectedOddsType)}</div>
            </div>);

        let potentialReturns = usingNonDecimalCurrency(systemCurrency) ? roundNumber(bet.Stake * bet.Market.Price, 0) : getPotentialReturn(bet.Market.Price, bet.Stake / BASE_VALUE, 1, 0);
        //Reduce stake from pot return if bet is probet
        if (!(bet.PromoId === 'real_bet')) {
            let stake = usingNonDecimalCurrency(systemCurrency) ? bet.Stake : roundNumber((bet.Stake) / BASE_VALUE, 2);
            potentialReturns = potentialReturns - stake
        }
        return (
            <div className={style.betHistoryRow} id={`${selectionIndex}_${bet.Market.Id}`}
                 key={`${selectionIndex}_${bet.Market.Id}`}>
                <div
                    className={style.betTypeStakeMultiplier}>{getText("Single", this.props.store)} - {`${getFormattedCurrency(this.props.store, usingNonDecimalCurrency(systemCurrency) ? bet.Stake : (bet.Stake / BASE_VALUE).toFixed(2), 2)}`}</div>
                <div className={style.selection}>
                    <div className={style.selectionConContainer}>{header} {data}</div>
                </div>
                <div
                    className={style.potentialReturns}>{`${getFormattedCurrency(this.props.store, potentialReturns, 2)}`}</div>
            </div>);
    }

    _generateAccaHistoryRowUI(subBets, multiplier, bonusPercentage, selectionIndex) {
        let storeData = this.props.store.getState().vpp;
        let systemCurrency = storeData.systemCurrency;
        let marketDetails = this._generateSelectionUI(subBets);
        let odds, stake, potentialReturns;
        odds = getRoundedOdds(subBets, false);
        stake = subBets[0].Stake / multiplier;
        potentialReturns = (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) ? getPotentialReturn(odds, stake, multiplier, bonusPercentage) :  getPotentialReturn(odds, stake / BASE_VALUE, multiplier, bonusPercentage);
        //Reduce stake from pot return if bet is probet
        if (!(subBets[0].PromoId === 'real_bet')) {
            let stake = usingNonDecimalCurrency(systemCurrency) ? subBets[0].Stake : roundNumber((subBets[0].Stake) / BASE_VALUE, 2);
            potentialReturns = potentialReturns - stake
        }
        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
            potentialReturns = Math.round(potentialReturns);
        }

        return (

            <div className={style.betHistoryRow} key={selectionIndex}>
                {<div className={style.betTypeStakeMultiplier}>
          <span className={style.betType}>
            {getText('1', this.props.store) + ' ' + getText('x', this.props.store) + ' '}
              {getAccaBetName(subBets.length, this.props.store)}
          </span>
                    <span
                        className={style.betStake}>{getFormattedCurrency(this.props.store, usingNonDecimalCurrency(systemCurrency) ? stake : (stake / BASE_VALUE).toFixed(2), 2)}</span>
                    <span
                        className={OPERATOR.maxRepeatBet > 1 ? style.multiplier : style.hideMultiplier}>x{multiplier}</span>
                </div>}
                <div className={style.selection}>
                    <div className={style.selectionConContainer}>{marketDetails}</div>
                </div>
                <div
                    className={style.potentialReturns}>{`${getFormattedCurrency(this.props.store, potentialReturns, 2)}`}</div>
            </div>)
            ;

    }

    _getSelectionName(bet) {
        let name;
        let homeTeam = getText("Matchday_" + bet.EventDetails.team1, this.props.store);
        let awayTeam = getText("Matchday_" + bet.EventDetails.team2, this.props.store);

        if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
            let marketDetails = JSON.parse(bet.OpaqueData);
            name = isNaN(marketDetails.selection)
                ? getText(marketDetails.selection, this.props.store, [homeTeam, awayTeam])
                : marketDetails.selection;
        }
        return name;
    }

    _frameSelectionUIByMarket(bet, marketCode) {
        let winningCss = `${style.matchdayBetContainer} ${style.win}`;
        let losingCss = `${style.matchdayBetContainer} ${style.lose}`;
        let resultUI = bet.filter((b) => b.Market.Code === marketCode)
            .map((subBet, index) => {
                return (<div
                    className={isWinningBet(subBet, this.state.games[this.state.selectedGameIndex], this.state.serverTimeOffset) ? winningCss : losingCss}
                    key={subBet.EventId}>
                    <div className={`${style.selectedBetDetail} ${style.left}`}>{this._getSelectionName(subBet)}</div>
                    <div
                        className={`${style.selectedBetDetailLarge} ${style.center}`}>{getText("Matchday_" + subBet.EventDetails.team1, this.props.store)}{this._getMatchdayEventLiveScore(subBet.EventId, subBet.EventTime)}{getText("Matchday_" + subBet.EventDetails.team2, this.props.store)}</div>
                    <div className={`${style.selectedBetDetail} ${style.right}`}>{subBet.Market.Price}</div>
                </div>);
            });
        return resultUI;
    }

    _generateSelectionUI(bet) {
        let marketIds = [];
        bet.map((subBet) => !marketIds.includes(subBet.Market.Code) ? marketIds.push(subBet.Market.Code) : '');

        let marketWiseCount = [];
        marketIds.map((marketId) => marketWiseCount.push([marketId, bet.filter((childBet) => childBet.Market.Code === marketId).length]));

        marketWiseCount.sort(function (a, b) {
            return b[1] - a[1];
        });

        let resultUI = [];
        for (let counter = 0; counter < marketWiseCount.length; counter++) {
            let market = getMarketByCode(marketWiseCount[counter][0]);
            resultUI = resultUI.concat(<div className={style.selectionHeader}
                                            key={market.name}>{market.name === UNDER_OVER_25.name ?
                getText("UNDER_OVER_2_5", this.props.store) : getText(market.name, this.props.store)}</div>);
            resultUI = resultUI.concat(this._frameSelectionUIByMarket(bet, marketWiseCount[counter][0]));
        }
        return (
            <div>
                {resultUI}
            </div>);
    }

    _generateMarketDetails(bet) {
        let selection = '';
        let marketName = getMatchDayMarketNameByCode(bet.Market.Code);

        marketName = getText(marketName
        === 'UNDER_OVER_25' ? 'UNDER_OVER_2_5' : marketName, this.props.store);
        if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
            let marketDetails = JSON.parse(bet.OpaqueData);
            let name = isNaN(marketDetails.selection)
                ? getText(marketDetails.selection, this.props.store)
                : marketDetails.selection;
            selection = [name];
        }

        return {name: marketName, selection}
    }

    render() {
        let activeBets = this.props.activeBets;

        let header = '';
        let content;
        if (activeBets && activeBets.length > 0) {
            header = this._generateHistoryHeaderRow();
            content = activeBets.map((ab, selectionIndex) => ab.Bets.length === 1 ? this._generateHistoryRowUI(ab.Bets[0], selectionIndex)
                : this._generateAccaHistoryRowUI(ab.Bets, ab.Multiplier, ab.Bonus, selectionIndex))
        } else {
            content = getText('NO_BETS_RESUME', this.props.store)
        }
        return (<div className={style.activeBetsResume}>
            <div className={style.summaryTitle}>{getText('BET_SUMMARY', this.props.store)}</div>
            {header}
            {content}
        </div>);
    }
}

export default connect(mapStateToProps)(MatchdayActiveBetsSummary);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/matchdayActiveBetsSummary.js